export const roleStats = [
    {
        title: "Roles",
        value: 8,
        subtitle: "Available in firm",
        icon: "shieldCheck",
        color: "#2563eb",
    },

    {
        title: "Employees Assigned",
        value: 142,
        subtitle: "Across all roles",
        icon: "users",
        color: "#10b981",
    },

    {
        title: "Permission Groups",
        value: 12,
        subtitle: "Modules protected",
        icon: "lock",
        color: "#8b5cf6",
    },

    {
        title: "Custom Roles",
        value: 3,
        subtitle: "Firm specific",
        icon: "settings",
        color: "#f59e0b",
    },
];
